import { SimpleEnvBase } from "../EnvBase";
import manifest from "./altego-manifest.json";

export class AlteGoEnv extends SimpleEnvBase(manifest) {

	/**
	 *  @override
	 */
	get environmentGroup() {
		return "altego";
	}
}

new AlteGoEnv();
